<router-outlet></router-outlet>
<ngx-spinner bdColor="rgba(0,0,0,0.8)" size="large" color="#fff" type="line-scale"><p style="color: white" > {{ msg }}... </p></ngx-spinner>